
import {
  ADD_TOKEN,
  ADD_USER,
  DELETE_TOKEN,
	GLOBAL_VARIABLE_ADD_categorias,

} from '../types/auth.types';

export const addLoftyToken = ({loftytoken, loftyuser}) => {
  localStorage.setItem('loftytoken', loftytoken);
  return {
    type: ADD_TOKEN,
    payload: {
      loftytoken, loftyuser,
    },
  };
};

export const deleteLoftytoken = () => {
  localStorage.removeItem('loftytoken');
  return {
    type: DELETE_TOKEN,
  };
};

export const addLoftyUser = (loftyuser) => ({
  type: ADD_USER,
  payload: {loftyuser},
});

export const set_lofty_global_categorias = (lofty_value) => {
	return ({
		type: GLOBAL_VARIABLE_ADD_categorias,
		payload: { lofty_global_categorias: lofty_value },
	});
}



